import { setSessionStorage } from '@/utils'
import { LOCAL_KEY_USER_NAME, LOCAL_KEY_USER_CODE, LOCAL_KEY_PART_NO, LOCAL_KEY_CSH_PIKER, LOCAL_KEY_ORDER_STATUS, LOCAL_KEY_ORDER_STATUS_INDEX,LOCAL_KEY_USERTYPE, LOCAL_KEY_USERTYPE_INDEX,LOCAL_KEY_SHOW_PERSONAL, LOCAL_KEY_SEARCH_CONTENT} from '@/config'

export default {
  setUserName(state, userName) {
    setSessionStorage(LOCAL_KEY_USER_NAME, userName)
    state.userName = userName
  },
  setUserCode(state, userCode) {
    setSessionStorage(LOCAL_KEY_USER_CODE, userCode)
    state.userCode = userCode
  },
  setPartNo(state, partNo) {
    setSessionStorage(LOCAL_KEY_PART_NO, partNo)
    state.partNo = partNo
  },
  setCshPicker(state, cshPicker) {
    setSessionStorage(LOCAL_KEY_CSH_PIKER, cshPicker)
    state.cshPicker = cshPicker
  },
  setOrderStatus(state, orderStatusList) {
    setSessionStorage(LOCAL_KEY_ORDER_STATUS, orderStatusList)
    state.orderStatusList = orderStatusList
  },
  setOrderStatusIndex(state, name) {
    setSessionStorage(LOCAL_KEY_ORDER_STATUS_INDEX, name)
    state.name = name
  },
  setUserType(state, userType) {
    setSessionStorage(LOCAL_KEY_USERTYPE, userType)
    state.userType = userType
  },
  setUserTypeIndex(state, name) {
    setSessionStorage(LOCAL_KEY_USERTYPE_INDEX, name)
    state.userTypeIndex = name
  },
  setShowPersonal(state, showPersonalFlg) {
    setSessionStorage(LOCAL_KEY_SHOW_PERSONAL, showPersonalFlg)
    state.showPersonalFlg = showPersonalFlg
  },
  setSearchContent(state, searchContent) {
    setSessionStorage(LOCAL_KEY_SEARCH_CONTENT, searchContent)
    state.searchContent = searchContent
  }
}

